import { render, staticRenderFns } from "./QuantityField.vue?vue&type=template&id=fbb85e6c&"
import script from "./QuantityField.vue?vue&type=script&lang=js&"
export * from "./QuantityField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbb85e6c')) {
      api.createRecord('fbb85e6c', component.options)
    } else {
      api.reload('fbb85e6c', component.options)
    }
    module.hot.accept("./QuantityField.vue?vue&type=template&id=fbb85e6c&", function () {
      api.rerender('fbb85e6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/orders/fields/QuantityField.vue"
export default component.exports